module.exports = __webpack_public_path__ + "img/0.8bf0a5cb.png";